import './BlockHeader.css';

function BlockHeader(props:{
    heading?: string,
    paragraph?: string,
}){
    return(
        <div className='accordion-block-header'>
            <h3 className='accordion-block-heading'>
                {props.heading}
            </h3>
            <p className='accordion-block-paragraph'>
                {props.paragraph}
            </p>
        </div>
    )
}

export default BlockHeader;